var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"characteristic"},[_c('div',{staticClass:"characteristic__head"},[_c('Icon',{attrs:{"name":_vm.iconName}}),_vm._v(" "),_c('Heading',{attrs:{"size":"h5"}},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")])],1),_vm._v(" "),_c('Paragraph',{staticClass:"characteristic__body"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }